import gql from 'graphql-tag';

export const exhibitionQuery = gql`
  query getExhibition($slug: ID!) {
    exhibition(id: $slug, idType: SLUG) {
      content
      dates {
        end {
          day
          month
          year
        }
        start {
          day
          month
          year
        }
        status
        label
      }
      excerpt
      featuredImage {
        node {
          altText
          description
          mediaDetails {
            height
            width
          }
          sourceUrl
        }
      }
      featuredImageFull {
        altText
        description
        imageSrcset
        mediaDetails {
          height
          width
        }
        sourceUrl
      }
      featuredImageWidth
      imageSrcset
      mediaBanner {
        altText
        caption
        carouselItems {
          altText
          caption
          enableDescription
          enableLink
          enablePlayPause
          enableSound
          imageFile
          imageSrcset
          imageUrl
          itemType
          linksTo
          muxLongVideoId
          muxShortVideoId
          muxVideoMobileId
        }
        enabled
        enableDescription
        enableLink
        enablePlayPause
        enableSound
        imageFile
        imageSrcset
        imageUrl
        itemType
        linksTo
        mediaType
        muxLongVideoId
        muxShortVideoId
        muxVideoMobileId
      }
      ticketLink
      title
    }
  }
`;
